"use strict";
const _ = require('lodash');
const { hasAllLocationsSet, hasAllPricesSet, hasAllRowsCounted, } = require('./properties');
function calculateTotalForRow(row) {
    if (!row.latestPurchasePrice || !row.countedQuantity)
        return 0;
    return _.round(row.countedQuantity * row.latestPurchasePrice, 2);
}
class Invariantor {
    constructor(stockTakingToEnsure) {
        this.stockTakingRows = stockTakingToEnsure.stockTakingRows || [];
        this.stockTaking = stockTakingToEnsure;
    }
    ensureStockTakingState() {
        if (this.stockTaking.stockTakingState === 'completed')
            return this;
        if (hasAllLocationsSet(this.stockTaking) &&
            this.stockTaking.stockTakingState === 'created') {
            this.stockTaking.stockTakingState = 'locationsAssigned';
        }
        if (_.find(this.stockTakingRows, x => _.isNumber(x.countedQuantity)) ||
            !_.includes(['created', 'locationsAssigned'], this.stockTaking.stockTakingState)) {
            this.stockTaking.stockTakingState = 'countStarted';
        }
        if (hasAllRowsCounted(this.stockTaking)) {
            this.stockTaking.stockTakingState = 'stocksTaken';
        }
        if (hasAllRowsCounted(this.stockTaking) &&
            hasAllPricesSet(this.stockTaking)) {
            this.stockTaking.stockTakingState = 'pricesSet';
        }
        return this;
    }
    ensureRowPriceAndTotal() {
        this.stockTakingRows = this.stockTakingRows.map(x => ({
            ...x,
            total: calculateTotalForRow(x),
        }));
        return this;
    }
    value() {
        return {
            ...this.stockTaking,
            stockTakingRows: this.stockTakingRows,
        };
    }
}
// invariants for the entity goes here
module.exports = stockTakingToEnsure => {
    const hadRows = !!stockTakingToEnsure.stockTakingRows;
    const ensured = new Invariantor(stockTakingToEnsure)
        .ensureStockTakingState()
        .ensureRowPriceAndTotal()
        .value();
    if (!hadRows) {
        delete ensured.stockTakingRows;
    }
    return ensured;
};
